import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Image,
  // ButtonGroup,
  Button,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import heroBackground from "../../assets/images/hero-background-about.png";
import partnerHeader from "../../assets/images/partner/partner-header.png";
import PartnerList from "./partner-list";
import { useLocation } from "react-router";
import { FaChevronUp, FaSearch } from "react-icons/fa";
import CheckCompany, {
  ValidUserType,
} from "../products/components/check-company";
import { PRODUCTS } from "../../constants/products";

function Partner() {
  const sectionRef = useRef<HTMLDivElement | null>(null);
  // const [activeFilters, setActiveFilters] = useState<string[]>([
  //   "employee-loan",
  //   "invoice-financing",
  //   "po-financing",
  //   "working-capital-loan",
  // ]);
  const [activeFilter, setActiveFilter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [hasResults, setHasResults] = useState(true);
  const location = useLocation();
  // const [hotelCount, setHotelCount] = useState(1);
  // const [foodCount, setFoodCount] = useState(1);
  // const [healthCount, setHealthCount] = useState(1);
  // const [othersCount, setOthersCount] = useState(1);
  const [isNoImage, setIsNoImage] = useState(false);

  const productFilters = [
    { id: "po-financing", name: PRODUCTS.poFinancing.title, color: "#4A4A49" },
    {
      id: "invoice-financing",
      name: PRODUCTS.invoiceFinancing.title,
      color: "#05A0C0",
    },
    {
      id: "working-capital-loan",
      name: PRODUCTS.capitalLoan.title,
      color: "#7A288A",
    },
    {
      id: "employee-loan",
      name: PRODUCTS.employeeLoan.title,
      color: "#009344",
    },
  ];

  const handleCheck = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    if (sectionRef.current) {
      const element = sectionRef.current;
      const offset = 60;
      if (element) {
        const top =
          element.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }
  };

  const toggleFilter = (id: string | null) => {
    // let updatedFilters = activeFilters.includes(id)
    // ? activeFilters.filter((filter) => filter !== id)
    // : [...activeFilters, id];

    // if (updatedFilters.length === 0) {
    //   updatedFilters = productFilters.map((f) => f.id);
    // }

    // setActiveFilters(updatedFilters);
    if (activeFilter === id) {
      setActiveFilter(null);
    } else {
      setActiveFilter(id);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const filter = params.get("filter");

    if (filter) {
      setActiveFilter(filter);
      // setActiveFilters([filter]);
    } else {
      setActiveFilter(null);
      // setActiveFilters([
      //   "employee-loan",
      //   "invoice-financing",
      //   "po-financing",
      //   "working-capital-loan",
      // ]);
    }
  }, [location.search]);

  // useEffect(()=>{
  //   let total = hotelCount + healthCount +  foodCount + othersCount;
  //   if(total < 1){
  //     setIsNoImage(true);
  //   }else{
  //     setIsNoImage(false);
  //   }
  // },[hotelCount,healthCount,foodCount,othersCount])

  const userTypes: ValidUserType[] = [];
  if (activeFilter) {
    if (activeFilter === "employee-loan") userTypes.push("employeeLoan");
    if (activeFilter === "invoice-financing")
      userTypes.push("invoiceFinancing");
    if (activeFilter === "po-financing") userTypes.push("poFinancing");
    if (activeFilter === "working-capital-loan") userTypes.push("capitalLoan");
  }
  // for (let a of activeFilters) {
  //   if (activeFilter === "employee-loan") userTypes.push("employeeLoan")
  //   if (activeFilter === "invoice-financing") userTypes.push("invoiceFinancing")
  //   if (activeFilter === "po-financing") userTypes.push("poFinancing")
  //   if (activeFilter === "working-capital-loan") userTypes.push("capitalLoan")
  // }
  const handleSearchResults = (hasData: boolean) => {
    setHasResults((prev) => prev || hasData);
  };

  const filterButtons = () => (
    <Row className="filter-group">
      <Col lg="auto" md="auto" sm="auto" xs="auto" className="mb-2 pe-0">
        <Button
          size="sm"
          onClick={() => toggleFilter(null)}
          className={`text-start filter-button ${activeFilter === null ? "active" : ""}`}
          // className={`text-start filter-button ${activeFilters.includes(filter.id) ? "active" : ""}`}
          style={{
            borderColor: "#828282",
            color: activeFilter === null ? "#FFF" : "#828282",
            backgroundColor: activeFilter === null ? "#828282" : "#FFF",
          }}
        >
          <span
            style={{
              display: "inline-block",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: activeFilter === null ? "#FFF" : "#828282",
              marginRight: "8px",
            }}
          ></span>
          Semua
        </Button>
      </Col>
      {productFilters.map((filter) => (
        <Col
          lg="auto"
          md="auto"
          sm="auto"
          xs="auto"
          className="mb-2 pe-0"
          key={filter.id}
        >
          <Button
            size="sm"
            onClick={() => toggleFilter(filter.id)}
            className={`text-start filter-button ${activeFilter === filter.id ? "active" : ""}`}
            // className={`text-start filter-button ${activeFilters.includes(filter.id) ? "active" : ""}`}
            style={{
              // borderColor: filter.color,
              // color: filter.color,
              borderColor: filter.color,
              color: activeFilter === filter.id ? "#FFF" : filter.color,
              // backgroundColor: activeFilters.includes(filter.id)
              backgroundColor:
                activeFilter === filter.id ? filter.color : "#FFF",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor:
                  activeFilter === filter.id ? "#FFF" : filter.color,
                marginRight: "8px",
              }}
            ></span>
            {filter.name}
          </Button>
        </Col>
      ))}
    </Row>
  );
  return (
    <div className="main-container" id="partner-page">
      <div
        className="hero-background-container about-banner position-relative"
        style={{
          backgroundImage: `url(${heroBackground})`,
        }}
      >
        <Container>
          <Row className="text-white justify-content-between">
            <Col
              xl={7}
              lg={6}
              md={12}
              sm={12}
              className="h-100 mt-xl-5 pt-lg-5"
            >
              <h1 className="text-size-title-2 fw-extra-bold banner-product-title">
                Peminjam Pohon Dana
              </h1>
              <div className="mt-2 text-size-body-head-2">
                Brand-brand yang telah percaya dan menggunakan layanan Pohon
                Dana
              </div>
            </Col>
            <Col
              xl={5}
              lg={6}
              className="d-none d-lg-flex justify-content-end text-end pt-lg-5"
            >
              <Image src={partnerHeader} fluid />
            </Col>
          </Row>
        </Container>
      </div>

      <Container
        className="mb-5 py-5"
        ref={(el) => {
          sectionRef.current = el;
        }}
      >
        <CheckCompany
          withProductFilter
          subtitle={filterButtons()}
          foundMessage=""
          notFoundMessage=""
          filters={userTypes}
        />
        <h1 className="mb-4 mt-5 text-center fw-extra-bold text-size-title-2">
          Daftar Peminjam / Mitra Pohon Dana
        </h1>

        {/* Filter Buttons */}
        <div className="bg-white p-2">
          <Row className="align-items-center">
            <Col lg={8} md={12}>
              {filterButtons()}
            </Col>
            <Col lg={4} md={12}>
              <div className="d-flex">
                <div className="form-search">
                  <div className="d-flex justify-content-center align-items-center p-2">
                    <FaSearch />
                  </div>
                  <div
                    style={{ width: "100%" }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <Form.Control
                      className="form-input-search"
                      type="text"
                      placeholder="Cari brand dari daftar di bawah"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <div className="text-end text-size-caption px-2">
            <a href="/" onClick={handleCheck}>
              Cek perusahaan secara lengkap / menyeluruh
            </a>
          </div>
        </div>

        {(!hasResults || isNoImage) && (
          <div className="d-flex justify-content-center align-items-center text-center py-5">
            <h5 className="text-muted">
              Perusahaan yang Anda cari tidak ditemukan
            </h5>
          </div>
        )}
        {/* Partner Lists */}
        <PartnerList
          // title="Hotel"
          // folder="hotel"
          filter={activeFilter ? [activeFilter] : []}
          searchQuery={searchQuery}
          onSearchResult={handleSearchResults}
          onImageCount={(count) => {
            // setHotelCount(count);
            if (count < 1) {
              setIsNoImage(true);
            } else {
              setIsNoImage(false);
            }
          }}
        />
        {/* <PartnerList
          title="Food and Beverages"
          folder="food_beverages"
          filter={activeFilters}
          searchQuery={searchQuery}
          onSearchResult={handleSearchResults}
          onImageCount={(count)=>{
            setFoodCount(count);
          }}
        />
        <PartnerList
          title="Healthcare"
          folder="healthcare"
          filter={activeFilters}
          searchQuery={searchQuery}
          onSearchResult={handleSearchResults}
          onImageCount={(count)=>{
            setHealthCount(count)
          }}
        />
        <PartnerList
          title="Others"
          folder="others"
          filter={activeFilters}
          searchQuery={searchQuery}
          onSearchResult={handleSearchResults}
          onImageCount={(count)=>{
            setOthersCount(count);
          }}
        /> */}
        <div className="mt-5">
          <div className="d-flex justify-content-center">
            <OverlayTrigger overlay={<Tooltip>Kembali ke atas</Tooltip>}>
              <div className="cursor-pointer text-center" onClick={handleCheck}>
                <FaChevronUp className="text-size-body-head" />
                <br />
                Kembali ke atas
              </div>
            </OverlayTrigger>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Partner;
